<template>
  <div>
    <b-form-group
      :label="$t('reusable.common.name')"
      label-for="input-title"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-title"
        name="input-title"
        v-model="$v.rubric_preset_unit.title.$model"
        :state="validateState('title')"
        aria-describedby="input-title-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 2 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description')"
      label-for="input-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div
        class="rubric_preset_unit-form-description mb-2"
        @click="
          $bvModal.show(
            `edit-rubric_preset_unit-description-modal-${rubric_preset_unit.id}`
          )
        "
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="rubric_preset_unit.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-rubric_preset_unit-description-modal-${rubric_preset_unit.id}`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="rubric_preset_unit"
        :content_rich_text="rubric_preset_unit.description"
        :show_last_modification="true"
        @save="
          (content) => patchRubricUnitDescription(rubric_preset_unit, content)
        "
        @close="
          $bvModal.hide(
            `edit-rubric_preset_unit-description-modal-${rubric_preset_unit.id}`
          )
        "
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-rubric_preset_unit-description-modal-${rubric_preset_unit.id}`"
        title="Editar Descripción de la Evaluación"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="rubric_preset_unit"
          :Text="rubric_preset_unit.description"
          @save="patchRubricUnitDescription"
          @close="
            $bvModal.hide(
              `edit-rubric_preset_unit-description-modal-${rubric_preset_unit.id}`
            )
          "
        ></NewRichTextEditor>
      </b-modal> -->
      <b-form-invalid-feedback id="input-description-feedback">{{
        $t("reusable.common.optional")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="
        (RubricPreset && RubricPreset.show_percentage_sign
          ? $t('curricularDefinitions.rubricPreset.percentage')
          : $t('curricularDefinitions.rubricPreset.score')) + ':'
      "
      label-for="input-score"
      label-cols="4"
      label-cols-sm="3"
    >
      <b-form-input
        id="input-score"
        v-model="$v.rubric_preset_unit.score.$model"
        :state="validateState('score')"
        aria-describedby="input-score-feedback"
        size="sm"
        type="number"
      ></b-form-input>
      <b-form-invalid-feedback id="input-score-feedback">
        <span>{{ $t("reusable.common.greaterThanOrEqualToZero") }}</span>
        <span v-if="RubricPreset && RubricPreset.show_percentage_sign">
          {{ $t("reusable.common.andLessThanOrEqualTo100") }}
        </span>
      </b-form-invalid-feedback>
    </b-form-group>

    <div class="row">
      <div
        v-if="show_delete_button && !isNaN(this.rubric_preset_unit.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="deleteRubricPreset"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="m-0" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { generateUniqueId } from "@/utils/utils";
import * as names from "@/store/names";
import { validationMixin } from "vuelidate";
import { required, minLength, minValue } from "vuelidate/lib/validators";
import { toast } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  name: "RubricPresetForm",
  mixins: [validationMixin],
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    RubricPreset: {
      type: Object,
      required: true,
    },
    RubricPresetUnit: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          title: "",
          description: "",
          order: 0,
          score: 0,
          rubric_preset: this.RubricPreset.id,
          created_by: null,
          creation_date: null,
          updated_by: null,
          update_date: null,
        };
      },
    },
    // Variable para que al guardar se cree el objeto en bd o enviarla por emit al componente padre al crear o editar.
    permit_local_rubric_preset_unit: {
      type: Boolean,
      default: false,
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rubric_preset_unit: { ...this.RubricPresetUnit },
    };
  },
  validations: {
    rubric_preset_unit: {
      title: {
        required,
        minLength: minLength(2),
      },
      description: {},
      score: {
        required,
        minValue: minValue(0),
        isValid() {
          if (this.RubricPreset && this.RubricPreset.show_percentage_sign) {
            if (this.rubric_preset_unit.score > 100) return false;
            else return true;
          } else return true;
        },
      },
    },
  },
  computed: {
    ...mapGetters({ rubric_preset_units: names.RUBRIC_PRESET_UNITS }),
  },
  created() {},
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.rubric_preset_unit[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.rubric_preset_unit.$touch();
      if (this.$v.rubric_preset_unit.$anyError) {
        return;
      }
      if (this.permit_local_rubric_preset_unit) {
        this.$emit("local_save", this.rubric_preset_unit);
      } else {
        if (isNaN(this.rubric_preset_unit.id)) {
          this.createRubricPreset();
        } else this.updateRubricPreset();
      }
    },
    patchRubricUnitDescription(object, text) {
      this.rubric_preset_unit.description = text;
    },
    createRubricPreset() {
      this.rubric_preset_unit.order = this.rubric_preset_units.length + 1;
      this.$store
        .dispatch(names.POST_RUBRIC_PRESET_UNIT, this.rubric_preset_unit)
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "evaluations.observationachievement",
                false,
                "Niveles de Logro"
              ) +
                " " +
                this.$t("reusable.common.created")
            )
          );
          this.$emit("created", response);
        });
    },
    updateRubricPreset() {
      this.$store
        .dispatch(names.UPDATE_RUBRIC_PRESET_UNIT, this.rubric_preset_unit)
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "evaluations.observationachievement",
                false,
                "Niveles de Logro"
              ) +
                " " +
                this.$t("reusable.common.updated")
            )
          );
          this.$emit("updated", response);
        });
    },
    deleteRubricPreset() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "evaluations.observationachievement",
            false,
            "Niveles de Logro"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            names.DELETE_RUBRIC_PRESET_UNIT,
            this.rubric_preset_unit.id
          );
          this.$emit("deleted", this.rubric_preset_unit);
        }
      });
    },
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.rubric_preset_unit-form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.25rem 1.2rem;
  line-height: 1.5;
}
.rubric_preset_unit-form-description >>> p {
  margin-bottom: 0.7rem !important;
}
</style>